export function trackFormSubmission(form: string) {
  try {
    fetch("https://insights.mycompartner.fr/api/public/track-submission", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ site_key: "mck_23de8b5b83fa6e50", form }),
      keepalive: true,
    }).catch(() => {});
  } catch {}
}